<template>
    <div>
        <div style="margin-top: 10px;">
            <p><h5>{{ $t('objects.details.orders') }}</h5></p>
        </div>
        <div>
            <p>{{ $t('objects.details.orders-desc') }}</p>
        </div>
        <div>
            <orders-list
                :mode="'onlyView'"
                :bus="bus"
                :ordertype="'byRentalObject'"
                :rmsobjectid="rmsobjectid"
            ></orders-list>
        </div>
    </div>
</template>

<script>
    const lazyOrdersList = () => import('../../orders/orders-list.vue');
    Vue.component('orders-list', lazyOrdersList);

    export default {
        name: "rms-objects-orders-tab",
        props: ['user', 'rmsobjectid'],
        data: function () {
            return {
                bus: new Vue(),
                userTime: '',
                userTimeZone: '',
                schemaModelFields: {
                    id: {editable: false, nullable: true},
                    name: {validation: {required: true}},
                    desc: {validation: {required: true}},
                    customer: {type: 'string', from: 'customer.displayName'},
                    from: {type: 'date'},
                    until: {type: 'date'},
                    dateStatus: {type: 'string'},
                    stateText: {type: 'string'},
                    attachedTags: {}
                }
            }
        }
    }
</script>

<style scoped>

</style>
